module.exports = __webpack_public_path__ + "static/media/Christiana Lackner.a2bc2f45.png";